import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  AfterViewChecked,
  OnDestroy,
  ChangeDetectorRef,
  HostListener,
} from "@angular/core";
import { Chat, Message, MessageData } from "../types";
import { takeUntil, takeWhile } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ChatService } from "../chat.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@aihub/core/authorization";
import { environment } from "@environments/environment";
import { AskGenAiService } from "../askGenAi.service";
import { PlanitService } from "../input/planit/planit.service";

@Component({
  selector: "app-chat-thread",
  templateUrl: "./chat-thread.component.html",
  styleUrls: ["./chat-thread.component.css"],
})
export class ChatThreadComponent implements OnInit, OnDestroy {
  @Input() subscription_id: string = "";
  isLoading = false;
  waitingMessage = false;
  showConversation = false;
  showDefault = true;
  showChatArea = true;
  environment = environment;
  response;
  request: string;
  jwt = "";
  private destroy$: Subject<boolean> = new Subject();
  streamSubscription: Subscription | undefined = undefined;
  messages: Message[] = [];
  loadChatOnQueryChange = true;
  conversation_id = "";
  isDestroyed: boolean = false;

  constructor(
    private readonly loginService: AuthService,
    private router: Router,
    private chatService: ChatService,
    private changeDetectorRef: ChangeDetectorRef,
    private askGenAi: AskGenAiService,
    private planitService: PlanitService
  ) {}

  @HostListener("window:beforeunload", ["$event"])
  unloadNotification($event: any): void {
    console.log("unloadNotification", $event);
  }

  ngOnInit() {
    if ((environment as any).products["kbin"]) {
      this.showConversation = true;
      this.showChatArea = false;
    }
    this.getJwt();
    this.planitService.planitLoading
      .pipe(takeWhile(() => !this.isDestroyed))
      .subscribe((isLoading) => {
        if (isLoading) {
          this.waitingMessage = true;
          this.showDefault = true;
        } else {
          this.waitingMessage = false;
        }
      });
    this.planitService.planitResponse
      .pipe(takeWhile(() => !this.isDestroyed))
      .subscribe((response) => {
        if (response) {
          this.showDefault = false;
          this.changeDetectorRef.detectChanges();
        }
      });
    this.planitService.subscription_id = this.subscription_id;
  }

  getJwt() {
    this.loginService
      .getJwtToken()
      // .pipe(takeUntil(this.destroy$))
      .subscribe((jwt: string) => {
        this.jwt = jwt;
      });
  }

  displayResponse(prompt: any): void {
    this.showDefault = true;
    this.request = prompt;
    this.response = "";

    if (typeof prompt === "object") {
      this.callPalmWithParams(prompt.promptString, prompt.model, prompt.modelParams);
    } else {
      this.addChat(prompt);
    }
  }

  clearResponse(response: any): void {
    this.response = response;
    this.showDefault = true;
  }

  addChat(prompt: string): void {
    this.chatService.addChat(this.subscription_id, prompt).subscribe((chat) => {
      this.getChatStream(chat.conversation_id);
      this.waitingMessage = true;
    });
  }

  getChatStream(conversation_id: string) {
    this.streamSubscription = this.chatService
      .getChatStream(this.subscription_id, conversation_id, this.jwt)
      // .pipe(takeUntil(this.destroy$))
      .subscribe((e: MessageData) => {
        // if (this.messages[this.messages.length - 1]?.role === "user") {
        //   this.messages.push({
        //     role: "assistant",
        //     content: "",
        //     timestamp: undefined,
        //   });
        // }
        if (e.message) {
          this.showDefault = false;
          this.response = e.message;
          console.log(this.response);
          this.waitingMessage = false;
          // this.messages[this.messages.length - 1].content += e.message;
          this.changeDetectorRef.detectChanges();
          this.ngOnDestroy();
          // this.scrollDown();
        }
        if (e.error) {
          this.messages[this.messages.length - 1].content = e.error;
          this.changeDetectorRef.detectChanges();
          // this.scrollDown();
          this.stopLoading();
        }
        if (e.finish_reason) {
          this.stopLoading();
        }
        // if (e.status === "inserted" && !this.conversation_id) {
        //   // if new chat is created
        //   this.loadChatOnQueryChange = false;
        //   this.router.navigate(["/"], {
        //     queryParams: {
        //       conversation_id,
        //     },
        //     queryParamsHandling: "merge",
        //   });
        // }
      });
  }

  callPalmWithParams(prompt: string, model: string = "text-bison", params: any): void {
    this.waitingMessage = true;
    this.askGenAi
      .askGenAi(this.subscription_id, prompt, undefined, model, params)
      .subscribe((data) => {
        if (data.model_responses[0]) {
          this.showDefault = false;
          this.waitingMessage = false;
          this.changeDetectorRef.detectChanges();
          //this.ngOnDestroy();
          this.response = data.model_responses[0];
          // console.log(this.response);
        }
      });
  }

  sendEmail() {
    let subject = "Feedback for " + environment.assetTitle;
    let body = "Hi there, ";
    let mailtoLink =
      "mailto:campfire@deloitte.de?subject=" +
      encodeURIComponent(subject) +
      "&body=" +
      encodeURIComponent(body);
    window.location.href = mailtoLink;
  }

  stopLoading(): void {
    this.isLoading = false;
    // this.waitingMessage = "";
    // if (this.dotCountInterval) {
    //   clearInterval(this.dotCountInterval);
    // }
    // if (this.waitingTimeout1) {
    //   clearTimeout(this.waitingTimeout1);
    // }
    // if (this.waitingTimeout2) {
    //   clearTimeout(this.waitingTimeout2);
    // }
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    // this.destroy$.next(true);
    // this.destroy$.complete();
    // this.destroy$ = null;
    // this.streamSubscription.unsubscribe();
    // this.streamSubscription = null;
  }
}
